import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading, Accent } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export const Faq = () => {
  const { t, c } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="bg-coal/40 border-y border-line py-24 md:py-36">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <SectionHeading kicker={t.faq.kicker} title={<Accent parts={t.faq.title} />} testid="faq-heading" />

        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {c.FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-line" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-serif text-xl md:text-2xl text-mist hover:text-gold hover:no-underline text-left py-6 transition-colors duration-300"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-dim leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
